module.exports = __webpack_public_path__ + "app-static/img/05-01.e1ae9857.png";